import React, { useRef, useState, useEffect } from 'react';
import { ExpandMore, ExpandLess } from '@material-ui/icons';

function ExpandableText({ children, maxHeight = 120 }) {
  const contentRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const element = contentRef.current;
    if (element) {
      setIsOverflowing(element.scrollHeight > element.clientHeight);
    }
  }, [children, maxHeight]);
  var maxHeight2 = 20;

  return (
    <div>
      <div
        ref={contentRef}
        style={{
          maxHeight: isExpanded ? 'none' : `${maxHeight}px`,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
        }}>
        {children}
      </div>
      {!isExpanded && isOverflowing && (
        <div
          style={{
            position: 'relative',
            bottom: `${maxHeight2}px`,
            left: 0,
            right: 0,
            height: '20px',
            pointerEvents: 'none',
            /* White background version */
            background: 'linear-gradient( to bottom,  rgba(255, 255, 255, 0),   rgba(255, 255, 255, 1) )',
          }}
        />
      )}

      {isOverflowing && (
        <span onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? <ExpandLess /> : <ExpandMore />}</span>
      )}
    </div>
  );
}

export default ExpandableText;
